<template>
  <div class="card-container" style="padding: 20px; padding-left: 30px">
    <ElInputWrapper>
      <BaseElFormItem label="車牌號碼" prop="vehicleInfoDetail.vehicle">
        <FlexLayout inline align="center" :gap="20" class="w-full">
          <BaseDataSelect
            :disabled="disabledControl.input.plate"
            :value.sync="context.vehicleInfoDetail.vehicle"
            style="width: 560px"
            :filterable="false"
            :dataList="memberVehicleList"
            labelKey="plate"
            valueKey="id"
            @change="onVehicleChange"
          />
          <BaseElButton type="primary" :disabled="disabledControl.btn.newVehicle" @click="modal.create = true">新增車牌</BaseElButton>
        </FlexLayout>
      </BaseElFormItem>

      <BaseElFormItem label="品牌" prop="vehicleInfoDetail.brandCode">
        <BaseDataSelect
          style="width: 560px"
          disabled
          :value.sync="context.vehicleInfoDetail.brandCode"
          :dataList="[
            {
              label: context.vehicleInfoDetail.vehicle?.brandName,
              value: context.vehicleInfoDetail.vehicle?.brandCode,
            }
          ]"
          objKey="value"
          labelKey="label"
          valueKey="value"
        />
      </BaseElFormItem>
      <BaseElFormItem label="型號" prop="vehicleInfoDetail.modelCode">
        <BaseDataSelect
          style="width: 560px"
          disabled
          :dataList="[
            {
              label: context.vehicleInfoDetail.vehicle?.typeName,
              value: context.vehicleInfoDetail.vehicle?.typeCode,
            }
          ]"
          :value.sync="context.vehicleInfoDetail.modelCode"
          labelKey="label"
          valueKey="value"
          objKey="value"
        />
      </BaseElFormItem>
      <BaseElFormItem label="尺寸" prop="vehicleInfoDetail.size" required :show-message="false">
        <BaseDataSelect
          style="width: 560px"
          :value.sync="context.vehicleInfoDetail.size"
          :dataList="displayVehicleSizeOptions"
          labelKey="label"
          valueKey="value"
          objKey="value"
          @change="onVehicleSizeChange"
        />
      </BaseElFormItem>
    </ElInputWrapper>

    <AppointmentCreateVehicleInfoModal
      v-if="modal.create"
      :memberId="memberId"
      :memberVehicleList="memberVehicleList"
      :vehicleModelSetData="vehicleModelSetData"
      @added="autoSelectVehicle"
      @close="modal.create = false"
      @refresh="getResources"
    />
  </div>
</template>

<script>
import BaseDataSelect from '@/components/Select/BaseDataSelect.vue'
import { computed, defineComponent, onBeforeMount, reactive, ref, watch } from 'vue'
import AppointmentCreateVehicleInfoModal from './AppointmentCreateVehicleInfoModal.vue'
import { useCreateAppointment } from '@/use/useCreateAppointment'
import ElInputWrapper from '@/components/ElInputWrapper.vue'
import { get, uniq, map } from 'lodash'
import {
  GetKeeperVehicleListByMember, GetKeeperVehicleTypeSet,
} from '@/api/keeper'
import { useShop } from '@/use/shop'

export default defineComponent({
  name: 'AppointmentVehicleInfoBlock',
  components: { BaseDataSelect, AppointmentCreateVehicleInfoModal, ElInputWrapper },
  setup (props, { emit }) {
    const { context, allCartItemReady, refreshOrderPrice } = useCreateAppointment()
    const { shopId } = useShop()

    const memberVehicleList = ref([])
    const vehicleModelSetData = ref([])

    const modal = reactive({
      create: false,
    })

    const memberId = computed(() => {
      return get(context.member, 'id')
    })

    const showControl = computed(() => {
      const controls = {}
      return controls
    })

    // disabledControl
    const disabledControl = computed(() => {
      const controls = {
        input: {
          plate: false,
        },
        btn: {
          newVehicle: false,
        },
      }

      if (context.userType === 'guest') {
        controls.input.plate = true
        controls.btn.newVehicle = true
      }

      return controls
    })

    const displayVehicleSizeOptions = computed(() => {
      // 顯示所有尺寸可能選項，因為後台可以隨意更改尺寸，不需受車型限制
      return map(uniq(map(vehicleModelSetData.value, 'size')), (size) => {
        return {
          label: size,
          value: size,
        }
      })
    })

    const onVehicleChange = async (vehicle) => {
      if (allCartItemReady.value) refreshOrderPrice()
      context.vehicleInfoDetail.modelCode = get(vehicle, 'typeCode') || undefined
      context.vehicleInfoDetail.brandCode = get(vehicle, 'brandCode') || undefined
      context.vehicleInfoDetail.size = get(vehicle, 'size') || undefined
    }

    const onVehicleSizeChange = async () => {
      if (allCartItemReady.value) {
        refreshOrderPrice()
      }
    }

    const getResources = async () => {
      const callList = [
        async () => {
          if (context.userType === 'guest' || !memberId.value) return
          const [res, errMsg] = await GetKeeperVehicleListByMember({
            shopId: shopId.value,
            memberId: memberId.value,
          })
          if (errMsg) {
            window.$message.error(errMsg)
            return
          }
          memberVehicleList.value = get(res, 'keeperVehicles', [])
        },
        async () => {
          const [res, errMsg] = await GetKeeperVehicleTypeSet({
            shopId: shopId.value,
          })
          if (errMsg) {
            window.$message.error(errMsg)
            return
          }
          vehicleModelSetData.value = get(res, 'data', [])
        },
      ]

      await Promise.all(callList.map((call) => call()))
    }

    const autoSelectVehicle = (vehicleData) => {
      context.vehicleInfoDetail.vehicle = vehicleData
      context.vehicleInfoDetail.modelCode = get(vehicleData, 'typeCode') || undefined
      context.vehicleInfoDetail.brandCode = get(vehicleData, 'brandCode') || undefined
      context.vehicleInfoDetail.size = get(vehicleData, 'size') || undefined
    }

    watch(memberId, async (newVal) => {
      if (!newVal) return
      await getResources()
    })

    onBeforeMount(() => {
      getResources()
    })

    return {
      context,
      disabledControl,
      showControl,
      modal,
      onVehicleChange,
      displayVehicleSizeOptions,
      memberVehicleList,
      vehicleModelSetData,
      memberId,
      getResources,
      onVehicleSizeChange,
      autoSelectVehicle,
    }
  },
})
</script>

<style lang="postcss" scoped>
.wrapper {

}
</style>
